/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContractCreateBodyAllOfDTO { 
    /**
     * Unique customer identifier. Used to link an contract to tenants.
     */
    customerIdentifier: string;
}

export class ClsContractCreateBodyAllOfDTO { 
    /**
     * Unique customer identifier. Used to link an contract to tenants.
     */
    customerIdentifier: string = undefined;
}

